import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import {
  SettingsSection,
  SettingsSectionContainer,
  SettingsSectionDescription,
  SettingsSectionTitle,
} from './nested/section'
import { SettingsGrid } from './nested/grid'
import {
  SettingsList,
  SettingsListItem,
  SettingsListItemActionsGroup,
  SettingsListItemDescription,
  SettingsListItemTitle,
  SettingsListItemTitleGroup,
} from './nested/list'
import { SettingsBanner } from './nested/banner'

function Settings({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div data-slot="settings" className={twMerge('flex flex-col gap-y-6 p-8 pt-10', className)} {...props}>
      {children}
    </div>
  )
}

Settings.Banner = SettingsBanner

Settings.Section = SettingsSection
Settings.SectionDescription = SettingsSectionDescription
Settings.SectionTitle = SettingsSectionTitle
Settings.SectionContainer = SettingsSectionContainer

Settings.Grid = SettingsGrid

Settings.List = SettingsList
Settings.ListItem = SettingsListItem
Settings.ListItemTitleGroup = SettingsListItemTitleGroup
Settings.ListItemTitle = SettingsListItemTitle
Settings.ListItemDescription = SettingsListItemDescription
Settings.ListItemActionsGroup = SettingsListItemActionsGroup

export { Settings }
